import type { MouseEvent } from 'react';

export type MenuPosition = {
  top: number;
  left: number;
};

export const getRowMenuPosition = (
  event: MouseEvent<HTMLElement>,
  rowSelector: string
): MenuPosition => {
  const rowElement = event.currentTarget.closest(rowSelector) as HTMLElement | null;
  const rect = (rowElement || event.currentTarget).getBoundingClientRect();

  return {
    top: Math.round(rect.top + rect.height / 2),
    left: Math.round(rect.right),
  };
};
